<template lang="pug">
  div
    .guide-modal(:class="{ open: showGuide }")
      a.guide-modal-close(@click="close")
        | 閉じる
      .guide-modal-title
        | 求人検索活用ガイド
      hooper(ref="carousel")
        slide
          .image-area(v-if="identifier () === 'kobot'")
            img(src="/static/images/guide/kobot/job-search1.png")
          .image-area(v-else-if="identifier () === 'mynavi'")
            img(src="/static/images/guide/mynavi/job-search1.png")
          .image-area(v-else)
            img(src="/static/images/guide/job-search1.png")
        slide
          .image-area(v-if="identifier () === 'kobot'")
            img(src="/static/images/guide/kobot/job-search2.png")
          .image-area(v-else-if="identifier () === 'mynavi'")
            img(src="/static/images/guide/mynavi/job-search2.png")
          .image-area(v-else)
            img(src="/static/images/guide/job-search2.png")
        slide
          .image-area(v-if="identifier () === 'kobot'")
            img(src="/static/images/guide/kobot/job-search3.png")
          .image-area(v-else-if="identifier () === 'mynavi'")
            img(src="/static/images/guide/mynavi/job-search3.png")
          .image-area(v-else)
            img(src="/static/images/guide/job-search3.png")
        slide
          .image-area(v-if="identifier () === 'kobot'")
            img(src="/static/images/guide/kobot/job-search4.png")
          .image-area(v-else-if="identifier () === 'mynavi'")
            img(src="/static/images/guide/mynavi/job-search4.png")
          .image-area(v-else)
            img(src="/static/images/guide/job-search4.png")
        hooper-pagination(slot="hooper-addons")
        hooper-navigation(slot="hooper-addons")
    .modal-cover
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper'
  import 'hooper/dist/hooper.css'

  export default {
    components: { Hooper, Slide, HooperPagination, HooperNavigation },
    computed: {
      ...mapGetters({
        showGuide: 'guide/showJobGuide',
      }),
    },
    watch: {
      showGuide () {
        this.$refs.carousel.restart()
      },
    },
    methods: {
      close () {
        this.$store.commit('guide/hideJobModal')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobGuideModal.vue